import { useQuery } from "react-query";
import { getOwnerIvideon } from "../requests/getOwnerIvideon";

export default function useGetOwnerIvideon(id: string, switched: boolean) {
  return useQuery({
    queryKey: ["owner", { id }],
    queryFn: () => getOwnerIvideon(id),
    refetchOnWindowFocus: false,
    enabled: switched,
  });
}
